// extracted by mini-css-extract-plugin
export var billingAddress = "_qb-g";
export var contactInfo = "_qb-d";
export var customerInfoContainer = "_qb-c";
export var customerInfoContainerMobile = "_qb-h";
export var customerInfoRow = "_qb-a";
export var customerInfoSection = "_qb-b";
export var fullWidthDividerMobile = "_qb-i";
export var imageContainer = "_qb-1";
export var paymentMethod = "_qb-e";
export var priceText = "_qb-6";
export var priceTextMobile = "_qb-7";
export var product = "_qb-0";
export var productImage = "_qb-2";
export var productInfo = "_qb-4";
export var productMobile = "_qb-9";
export var productTitle = "_qb-8";
export var quantityBadge = "_qb-3";
export var quantityText = "_qb-5";
export var shippingAddress = "_qb-f";